import { render } from "./authen.vue?vue&type=template&id=54320244&scoped=true"
import script from "./authen.vue?vue&type=script&lang=js"
export * from "./authen.vue?vue&type=script&lang=js"

import "./authen.vue?vue&type=style&index=0&id=54320244&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54320244"]])

export default __exports__